"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _native = _interopRequireDefault(require("styled-components/native"));
var _reactNativeHyperlink = _interopRequireDefault(require("react-native-hyperlink"));
var _color = _interopRequireDefault(require("../../Components/styles/color"));
var _linkifyReact = _interopRequireDefault(require("linkify-react"));
var _Helper = _interopRequireDefault(require("../../Components/Helper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var getPrimaryFontFamily = function getPrimaryFontFamily(props) {
  return 'Roboto';
};
var getSecondaryFontFamily = function getSecondaryFontFamily(props) {
  return 'Raleway';
};
var getFontWeight = function getFontWeight(props) {
  var a = props.fonttype;
  var weight = 400;
  switch (a) {
    case 'h1':
      weight = 300;
      break;
    case 'h2':
      weight = 500;
      break;
    case 'h3':
      weight = 500;
      break;
    case 'h4':
      weight = 700;
      break;
    case 'h5':
      weight = 400;
      break;
    case 'h6':
      weight = 400;
      break;
    case 'p':
      weight = 400;
      break;
    case 'th':
      weight = 700;
      break;
  }
  return weight;
};

/* istanbul ignore next */
var H1 = _native["default"].Text.withConfig({
  displayName: "H1",
  componentId: "sc-k897mw-0"
})(["font-family:", ";font-weight:", ";font-size:36px;letter-spacing:0;line-height:42px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getSecondaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var H2 = _native["default"].Text.withConfig({
  displayName: "H2",
  componentId: "sc-k897mw-1"
})(["font-family:", ";font-weight:", ";font-size:30px;letter-spacing:0;line-height:35px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getSecondaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var H3 = _native["default"].Text.withConfig({
  displayName: "H3",
  componentId: "sc-k897mw-2"
})(["font-family:", ";font-weight:", ";font-size:24px;letter-spacing:0;line-height:28px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getSecondaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var H4 = _native["default"].Text.withConfig({
  displayName: "H4",
  componentId: "sc-k897mw-3"
})(["font-family:", ";font-weight:", ";font-size:18px;letter-spacing:0;line-height:21px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getPrimaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var H5 = _native["default"].Text.withConfig({
  displayName: "H5",
  componentId: "sc-k897mw-4"
})(["font-family:", ";font-weight:", ";font-size:14px;letter-spacing:0;line-height:18px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getPrimaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var H6 = _native["default"].Text.withConfig({
  displayName: "H6",
  componentId: "sc-k897mw-5"
})(["font-family:", ";font-weight:", ";font-size:12px;letter-spacing:0;line-height:14px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getPrimaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var TableHeader = _native["default"].Text.withConfig({
  displayName: "TableHeader",
  componentId: "sc-k897mw-6"
})(["font-family:", ";font-weight:", ";font-size:12px;letter-spacing:0;line-height:14px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getPrimaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var Paragraph = _native["default"].Text.withConfig({
  displayName: "Paragraph",
  componentId: "sc-k897mw-7"
})(["font-family:", ";font-weight:", ";font-size:16px;letter-spacing:0;line-height:24px;color:", ";text-transform:", ";text-align:", ";"], function (props) {
  return getPrimaryFontFamily(props);
}, function (props) {
  return getFontWeight(props);
}, function (props) {
  return props.fontcolor;
}, function (props) {
  return props.texttransform;
}, function (props) {
  return props.align || 'left';
});
/* istanbul ignore next */
var Container = _native["default"].View.withConfig({
  displayName: "Container",
  componentId: "sc-k897mw-8"
})(["", " ", ""], function (props) {
  return props.align ? "align-items: ".concat(props.align, ";") : '';
}, function (props) {
  return props.ellipsis ? 'width: 100%;' : '';
});

// add for testing purpose
Container.displayName = 'Container';
H1.displayName = 'H1';
H2.displayName = 'H2';
H3.displayName = 'H3';
H4.displayName = 'H4';
H5.displayName = 'H5';
H6.displayName = 'H6';
Paragraph.displayName = 'Paragraph';
TableHeader.displayName = 'TableHeader';
var textTypes = {
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  p: Paragraph,
  th: TableHeader
};

/**
 * Text Component that allows various font style, weight, size and line height
 * Component can be used for React Native and Web projects
 */
function Text(props) {
  var testID = props.testID,
    text = props.text,
    children = props.children,
    ellipsis = props.ellipsis,
    fontColor = props.fontColor,
    onPress = props.onPress,
    onClick = props.onClick,
    textTransform = props.textTransform,
    linkify = props.linkify,
    align = props.align,
    numberOfLines = props.numberOfLines,
    textSize = props.textSize,
    noScaling = props.noScaling;
  /**
   * Fix warning, styled components takes in 1/0 for booleans
   */
  var formatedEllipsis = ellipsis ? 1 : 0;
  var getText = function getText() {
    var defaultTextSize = textSize || 'p';
    var CustomText = textTypes[defaultTextSize];
    var allowFontScaling = !noScaling;
    var ellipsisStyling = '';
    if (ellipsis) {
      ellipsisStyling = "\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: inherit;\n        white-space: nowrap;\n      ";
    }
    var linkedText = function linkedText(linkify, text) {
      var linkedText = /*#__PURE__*/_react["default"].createElement(CustomText, {
        testID: testID || 'Text',
        "data-cy": testID || 'Text',
        fonttype: textSize,
        fontcolor: fontColor,
        align: align || 'left',
        onPress: onPress,
        onClick: onClick,
        numberOfLines: numberOfLines,
        texttransform: textTransform || 'none',
        allowFontScaling: allowFontScaling,
        ellipsis: formatedEllipsis,
        ellipsisstyling: ellipsisStyling
      }, text);
      if (linkify && text) {
        var renderedText = /*#__PURE__*/_react["default"].createElement(CustomText, {
          ellipsisstyling: ellipsisStyling,
          fonttype: textSize,
          testID: testID || 'Text',
          "data-cy": testID || 'Text',
          fontcolor: fontColor,
          align: align || 'left',
          onPress: onPress,
          onClick: onClick,
          numberOfLines: numberOfLines,
          texttransform: textTransform || 'none',
          allowFontScaling: allowFontScaling,
          ellipsizeMode: "tail"
        }, text);
        if (!_Helper["default"].isWeb()) {
          linkedText = /*#__PURE__*/_react["default"].createElement(_reactNativeHyperlink["default"], {
            linkDefault: true,
            linkStyle: {
              color: _color["default"].info
            }
          }, renderedText);
        } else {
          linkedText = /*#__PURE__*/_react["default"].createElement(_linkifyReact["default"], {
            options: {
              attributes: {
                key: testID || 'Text'
              },
              target: 'blank'
            }
          }, renderedText);
        }
      }
      return linkedText;
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, linkedText(linkify, text), children);
  };
  var bodyText = getText();
  if (!_Helper["default"].isWeb()) {
    return bodyText;
  }
  return /*#__PURE__*/_react["default"].createElement(Container, {
    align: align,
    ellipsis: formatedEllipsis
  }, bodyText);
}
var _default = Text;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(getPrimaryFontFamily, "getPrimaryFontFamily", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(getSecondaryFontFamily, "getSecondaryFontFamily", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(getFontWeight, "getFontWeight", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(H1, "H1", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(H2, "H2", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(H3, "H3", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(H4, "H4", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(H5, "H5", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(H6, "H6", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(TableHeader, "TableHeader", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(Paragraph, "Paragraph", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(textTypes, "textTypes", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(Text, "Text", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/Typography/Text.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();